export default __webpack_public_path__ + "/dist/images/image00021.5b5e4775f6348a794ac07e381aab5ac8.jpg";